import React from "react";
export function getCloseHandler(modalRef, header, onBeforeClose) {
    if (header && header.closeButton === false)
        return undefined;
    if (onBeforeClose) {
        return () => { var _a; return onBeforeClose() !== false && ((_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.close()); };
    }
    return () => { var _a; return (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.close(); };
}
export function useBodyScrollLock(modalRef, bodyClass) {
    React.useEffect(() => {
        if (!modalRef.current)
            return;
        if (modalRef.current.open)
            document.body.classList.add(bodyClass); // In case `open` is true initially
        const observer = new MutationObserver(() => {
            var _a;
            if ((_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.open)
                document.body.classList.add(bodyClass);
            else
                document.body.classList.remove(bodyClass);
        });
        observer.observe(modalRef.current, {
            attributes: true,
            attributeFilter: ["open"],
        });
        return () => {
            observer.disconnect();
            document.body.classList.remove(bodyClass); // In case modal is unmounted before it's closed
        };
    }, [modalRef, bodyClass]);
}
//# sourceMappingURL=ModalUtils.js.map